// extracted by mini-css-extract-plugin
module.exports = {"styles":"_3jGCp5VsvHdarl5riSy4uK"};